import { Badge, Button } from "@heroui/react";
import { toast } from "sonner";
import { deployL2Token } from "../../actions/deployToken";

export function NewL2TokenButton() {
  const isDevMode = import.meta.env.DEV;

  if (!isDevMode) {
    return null;
  }

  return (
    <Badge color="danger" size="sm" showOutline={false} content="DEV">
      <Button
        onPress={async () => {
          const tokenAddr = await deployL2Token();
          toast.info(`Deployed token at ${tokenAddr}`);
        }}
      >
        New token
      </Button>
    </Badge>
  );
}
